import { InfinityTagDescription } from "../interfaces/infinity-tags.interface";

export const TagsInfinityWeb = [    
    { key: '/home', value: 'Home' },
    { key: '/home#main', value: 'Home' },
    { key: '/home#how-it-works', value: '¿Cómo funciona?' },
    { key: '/home#benefits', value: 'Beneficios' },
    { key: '/home#offers', value: 'Promociones' },
    { key: '/home#app-home', value: 'App' },
    { key: '/home#locations', value: 'Sucursales' },
    { key: '/reset-password#reset-password', value: 'Olvidé mi contraseña' },
    { key: '/register', value: 'Registrate' },
    { key: '/terms-conditions', value: 'Terminos y condiciones' },
    { key: '/privacy-policy', value: 'Aviso de privacidad' },
    { key: '/dashboard/my-account/overview', value: 'Mi Cuenta' },
    { key: '/dashboard/benefit/products/dishes', value: 'Beneficios platillos' },
    { key: '/dashboard/benefit/products/promotions', value: 'Beneficios promociones' },
    { key: '/dashboard/card/details', value: 'Detalle de tarjeta' },
    { key: '/dashboard/card-registration', value: 'Activar tarjeta adquirida en sucursal' },
    { key: '/dashboard/card/accumulation', value: 'Acumulación manual' },
    { key: '/dashboard/card/movements', value: 'Movimientos' },
    { key: '/dashboard/coupons', value: 'Cupones' },
    { key: '/dashboard/notifications', value: 'Notificaciones' },
    { key: '/dashboard/my-account/edit-my-data', value: 'Editar datos' },
    { key: '/dashboard/my-account/change-password', value: 'Modificar contraseña' },
    { key: '/dashboard/my-account/cancel-membership', value: 'Cancelar membresía' },
    { key: '/dashboard/benefit/donate', value: 'Dona' },
    { key: '/dashboard/benefit/products/experiences', value: 'Experiencias' },
] satisfies InfinityTagDescription[];